module.exports = __webpack_public_path__ + "img/results-1.fded0c5e.png";